import React, { useMemo } from "react";
import styled from "styled-components";
import { WidgetHeader } from "../../WidgetBarChart/WIDGET_ELEM_ConfigForm";
import { WidgetFilters } from "../../utils/WidgetFilters";
import { getWidgetContentTypes, getWidgetHasDimensions } from "../../utils/getWidgetContentTypes";
import { CollapseTransition } from "../../utils/CollapseTransition";

import { MetricCardConfigProvider, useMetricCardConfig } from "./ConfigForm_Context";
import { ConfigForm_SectionWrapper } from "./ConfigForm_SectionWrapper";
import { ConfigForm_CaptionSection } from "./ConfigForm_CaptionSection";
import { ConfigForm_DataSection } from "./ConfigForm_DataSection";
import { ConfigForm_ConfigureSection } from "./ConfigForm_ConfigureSection";
import { ConfigForm_DisplaySection } from "./ConfigForm_DisplaySection";
import { useWidgetFilterControls } from "../../utils/useWidgetFilterControls";

const StyledSectionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
`;


const ConfigFormContent = ({ thisWidgetConfig, setConfig, underEditWidgetIdx, widgetIcon, widgetTitle }) => {
  const { showConfigureSection, showDisplaySection } = useMetricCardConfig();

  const widgetType = thisWidgetConfig?.comp || 'WidgetMetricCard';
  const contentTypesForFilters = useMemo(() => {
    return getWidgetContentTypes(thisWidgetConfig, widgetType);
  }, [thisWidgetConfig, widgetType]);

  const hasDimensions = getWidgetHasDimensions(thisWidgetConfig, widgetType);
  const { filterHeaderProps, filterControlProps } = useWidgetFilterControls({
    hasDimensions
  });

  return (
    <StyledSectionsWrapper>

      <WidgetHeader title={widgetTitle} type={"Metric"} icon={widgetIcon} />

      <ConfigForm_CaptionSection />

      <ConfigForm_DataSection />

      <CollapseTransition isVisible={showConfigureSection} id="configure-section">
        <ConfigForm_ConfigureSection />
      </CollapseTransition>

      <CollapseTransition isVisible={showDisplaySection} id="display-section">
        <ConfigForm_DisplaySection />
      </CollapseTransition>
      
      <ConfigForm_SectionWrapper
        icon="Funnel"
        title="Filters"
        {...filterHeaderProps}
      >
        <WidgetFilters
          widgetConfig={thisWidgetConfig}
          updateWidgetConfig={setConfig}
          widgetIndex={underEditWidgetIdx}
          contentTypesForFilters={contentTypesForFilters}
          {...filterControlProps}
        />
      </ConfigForm_SectionWrapper>


    </StyledSectionsWrapper>
  );
};


export const WIDGET_ELEM_ConfigForm = ({
  thisWidgetConfig,
  setConfig,
  underEditWidgetIdx,
  widgetIcon = "Hash",
  widgetTitle = "Number Basic"
}) => {
  return (
    <MetricCardConfigProvider
      thisWidgetConfig={thisWidgetConfig}
      setConfig={setConfig}
      underEditWidgetIdx={underEditWidgetIdx}
    >
      <ConfigFormContent
        thisWidgetConfig={thisWidgetConfig}
        setConfig={setConfig}
        underEditWidgetIdx={underEditWidgetIdx}
        widgetIcon={widgetIcon}
        widgetTitle={widgetTitle}
      />
    </MetricCardConfigProvider>
  );
};
